
// client/generated/CardArt.ts
// @generated

import ArtAcademy from '../../assets/card_images/ArtAcademy.jpg';
import ArtAcolyteOfZeona from '../../assets/card_images/ArtAcolyteOfZeona.jpg';
import ArtAcropolis from '../../assets/card_images/ArtAcropolis.jpg';
import ArtAltarOfBounty from '../../assets/card_images/ArtAltarOfBounty.jpg';
import ArtAmbush from '../../assets/card_images/ArtAmbush.jpg';
import ArtAqueduct from '../../assets/card_images/ArtAqueduct.jpg';
import ArtArchitect from '../../assets/card_images/ArtArchitect.jpg';
import ArtAscension from '../../assets/card_images/ArtAscension.jpg';
import ArtAxeman from '../../assets/card_images/ArtAxeman.jpg';
import ArtBarracks from '../../assets/card_images/ArtBarracks.jpg';
import ArtBastion from '../../assets/card_images/ArtBastion.jpg';
import ArtBathhouse from '../../assets/card_images/ArtBathhouse.jpg';
import ArtBattleHymn from '../../assets/card_images/ArtBattleHymn.jpg';
import ArtBlessedBounty from '../../assets/card_images/ArtBlessedBounty.jpg';
import ArtBlessedMight from '../../assets/card_images/ArtBlessedMight.jpg';
import ArtCaptain from '../../assets/card_images/ArtCaptain.jpg';
import ArtCaravan from '../../assets/card_images/ArtCaravan.jpg';
import ArtCitadel from '../../assets/card_images/ArtCitadel.jpg';
import ArtPalisades from '../../assets/card_images/ArtPalisades.jpg';
import ArtCommander from '../../assets/card_images/ArtCommander.jpg';
import ArtConscription from '../../assets/card_images/ArtConscription.jpg';
import ArtCourthouse from '../../assets/card_images/ArtCourthouse.jpg';
import ArtCraftsman from '../../assets/card_images/ArtCraftsman.jpg';
import ArtDespoticLeader from '../../assets/card_images/ArtDespoticLeader.jpg';
import ArtDivineBlessing from '../../assets/card_images/ArtDivineBlessing.jpg';
import ArtFarm from '../../assets/card_images/ArtFarm.jpg';
import ArtFolkHero from '../../assets/card_images/ArtFolkHero.jpg';
import ArtForge from '../../assets/card_images/ArtForge.jpg';
import ArtOverflowingBounty from '../../assets/card_images/ArtOverflowingBounty.jpg';
import ArtQuarry from '../../assets/card_images/ArtQuarry.jpg';
import ArtGlory from '../../assets/card_images/ArtGlory.jpg';
import ArtGranary from '../../assets/card_images/ArtGranary.jpg';
import ArtGrandSiege from '../../assets/card_images/ArtGrandSiege.jpg';
import ArtGreatOliveTree from '../../assets/card_images/ArtGreatOliveTree.jpg';
import ArtGrowth from '../../assets/card_images/ArtGrowth.jpg';
import ArtGuardHound from '../../assets/card_images/ArtGuardHound.jpg';
import ArtWatchtower from '../../assets/card_images/ArtWatchtower.jpg';
import ArtGuidance from '../../assets/card_images/ArtGuidance.jpg';
import ArtTownHall from '../../assets/card_images/ArtTownHall.jpg';
import ArtHallOfChampions from '../../assets/card_images/ArtHallOfChampions.jpg';
import ArtHarvestSeason from '../../assets/card_images/ArtHarvestSeason.jpg';
import ArtHeroesFeast from '../../assets/card_images/ArtHeroesFeast.jpg';
import ArtHighPriest from '../../assets/card_images/ArtHighPriest.jpg';
import ArtHarvestFestival from '../../assets/card_images/ArtHarvestFestival.jpg';
import ArtHonorTheFallen from '../../assets/card_images/ArtHonorTheFallen.jpg';
import ArtHoplite from '../../assets/card_images/ArtHoplite.jpg';
import ArtHorseman from '../../assets/card_images/ArtHorseman.jpg';
import ArtTempleGuard from '../../assets/card_images/ArtTempleGuard.jpg';
import ArtLayFoundation from '../../assets/card_images/ArtLayFoundation.jpg';
import ArtLeader from '../../assets/card_images/ArtLeader.jpg';
import ArtLegionnaire from '../../assets/card_images/ArtLegionnaire.jpg';
import ArtLibrary from '../../assets/card_images/ArtLibrary.jpg';
import ArtLighthouse from '../../assets/card_images/ArtLighthouse.jpg';
import ArtMarchOnward from '../../assets/card_images/ArtMarchOnward.jpg';
import ArtMarketplace from '../../assets/card_images/ArtMarketplace.jpg';
import ArtMercantileLeader from '../../assets/card_images/ArtMercantileLeader.jpg';
import ArtMercenary from '../../assets/card_images/ArtMercenary.jpg';
import ArtMerchant from '../../assets/card_images/ArtMerchant.jpg';
import ArtConqueringLeader from '../../assets/card_images/ArtConqueringLeader.jpg';
import ArtMilitia from '../../assets/card_images/ArtMilitia.jpg';
import ArtMillOfDerion from '../../assets/card_images/ArtMillOfDerion.jpg';
import ArtMine from '../../assets/card_images/ArtMine.jpg';
import ArtNewRoads from '../../assets/card_images/ArtNewRoads.jpg';
import ArtDemocraticOath from '../../assets/card_images/ArtDemocraticOath.jpg';
import ArtAutocraticOath from '../../assets/card_images/ArtAutocraticOath.jpg';
import ArtTheocraticOath from '../../assets/card_images/ArtTheocraticOath.jpg';
import ArtOracle from '../../assets/card_images/ArtOracle.jpg';
import ArtPiety from '../../assets/card_images/ArtPiety.jpg';
import ArtPillage from '../../assets/card_images/ArtPillage.jpg';
import ArtPiousLeader from '../../assets/card_images/ArtPiousLeader.jpg';
import ArtWarsinger from '../../assets/card_images/ArtWarsinger.jpg';
import ArtPrizedOx from '../../assets/card_images/ArtPrizedOx.jpg';
import ArtProphet from '../../assets/card_images/ArtProphet.jpg';
import ArtRanger from '../../assets/card_images/ArtRanger.jpg';
import ArtRitualOfPolis from '../../assets/card_images/ArtRitualOfPolis.jpg';
import ArtRitualOfHeroes from '../../assets/card_images/ArtRitualOfHeroes.jpg';
import ArtRitual from '../../assets/card_images/ArtRitual.jpg';
import ArtScavenge from '../../assets/card_images/ArtScavenge.jpg';
import ArtScout from '../../assets/card_images/ArtScout.jpg';
import ArtScribe from '../../assets/card_images/ArtScribe.jpg';
import ArtPantheon from '../../assets/card_images/ArtPantheon.jpg';
import ArtLaborCamp from '../../assets/card_images/ArtLaborCamp.jpg';
import ArtSoldierOfTyros from '../../assets/card_images/ArtSoldierOfTyros.jpg';
import ArtStonemason from '../../assets/card_images/ArtStonemason.jpg';
import ArtStrategist from '../../assets/card_images/ArtStrategist.jpg';
import ArtStrength from '../../assets/card_images/ArtStrength.jpg';
import ArtSwordsman from '../../assets/card_images/ArtSwordsman.jpg';
import ArtTemple from '../../assets/card_images/ArtTemple.jpg';
import ArtGuardsman from '../../assets/card_images/ArtGuardsman.jpg';
import ArtAltarOfStars from '../../assets/card_images/ArtAltarOfStars.jpg';
import ArtTradeDeal from '../../assets/card_images/ArtTradeDeal.jpg';
import ArtTradingPost from '../../assets/card_images/ArtTradingPost.jpg';
import ArtTrainingCamp from '../../assets/card_images/ArtTrainingCamp.jpg';
import ArtVillager from '../../assets/card_images/ArtVillager.jpg';
import ArtVineyard from '../../assets/card_images/ArtVineyard.jpg';
import ArtWanderingLeader from '../../assets/card_images/ArtWanderingLeader.jpg';
import ArtWarHistorian from '../../assets/card_images/ArtWarHistorian.jpg';
import ArtWarrior from '../../assets/card_images/ArtWarrior.jpg';
import ArtWorship from '../../assets/card_images/ArtWorship.jpg';
import TributeArtAllIn from '../../assets/card_images/TributeArtAllIn.jpg';
import TributeArtBringPeace from '../../assets/card_images/TributeArtBringPeace.jpg';
import TributeArtGrowBounty from '../../assets/card_images/TributeArtGrowBounty.jpg';
import TributeArtGrowCommunity from '../../assets/card_images/TributeArtGrowCommunity.jpg';
import TributeArtGrowConquest from '../../assets/card_images/TributeArtGrowConquest.jpg';
import TributeArtGrowFaith from '../../assets/card_images/TributeArtGrowFaith.jpg';
import TributeArtGrowLegend from '../../assets/card_images/TributeArtGrowLegend.jpg';
import TributeArtGrowPolis from '../../assets/card_images/TributeArtGrowPolis.jpg';
import TributeArtImpulsiveChoice from '../../assets/card_images/TributeArtImpulsiveChoice.jpg';
import TributeArtOverpower from '../../assets/card_images/TributeArtOverpower.jpg';
import TributeArtPatientChoice from '../../assets/card_images/TributeArtPatientChoice.jpg';
import TributeArtPersevere from '../../assets/card_images/TributeArtPersevere.jpg';
import TributeArtPunishWeakness from '../../assets/card_images/TributeArtPunishWeakness.jpg';
import TributeArtSeekHumility from '../../assets/card_images/TributeArtSeekHumility.jpg';
import TributeArtSeekModesty from '../../assets/card_images/TributeArtSeekModesty.jpg';
import TributeArtSeekWonder from '../../assets/card_images/TributeArtSeekWonder.jpg';
import TributeArtShowMight from '../../assets/card_images/TributeArtShowMight.jpg';
import TributeArtShowPiety from '../../assets/card_images/TributeArtShowPiety.jpg';

export const CardArt = {
  "ArtAcademy.jpg": ArtAcademy,
  "ArtAcolyteOfZeona.jpg": ArtAcolyteOfZeona,
  "ArtAcropolis.jpg": ArtAcropolis,
  "ArtAltarOfBounty.jpg": ArtAltarOfBounty,
  "ArtAmbush.jpg": ArtAmbush,
  "ArtAqueduct.jpg": ArtAqueduct,
  "ArtArchitect.jpg": ArtArchitect,
  "ArtAscension.jpg": ArtAscension,
  "ArtAxeman.jpg": ArtAxeman,
  "ArtBarracks.jpg": ArtBarracks,
  "ArtBastion.jpg": ArtBastion,
  "ArtBathhouse.jpg": ArtBathhouse,
  "ArtBattleHymn.jpg": ArtBattleHymn,
  "ArtBlessedBounty.jpg": ArtBlessedBounty,
  "ArtBlessedMight.jpg": ArtBlessedMight,
  "ArtCaptain.jpg": ArtCaptain,
  "ArtCaravan.jpg": ArtCaravan,
  "ArtCitadel.jpg": ArtCitadel,
  "ArtPalisades.jpg": ArtPalisades,
  "ArtCommander.jpg": ArtCommander,
  "ArtConscription.jpg": ArtConscription,
  "ArtCourthouse.jpg": ArtCourthouse,
  "ArtCraftsman.jpg": ArtCraftsman,
  "ArtDespoticLeader.jpg": ArtDespoticLeader,
  "ArtDivineBlessing.jpg": ArtDivineBlessing,
  "ArtFarm.jpg": ArtFarm,
  "ArtFolkHero.jpg": ArtFolkHero,
  "ArtForge.jpg": ArtForge,
  "ArtOverflowingBounty.jpg": ArtOverflowingBounty,
  "ArtQuarry.jpg": ArtQuarry,
  "ArtGlory.jpg": ArtGlory,
  "ArtGranary.jpg": ArtGranary,
  "ArtGrandSiege.jpg": ArtGrandSiege,
  "ArtGreatOliveTree.jpg": ArtGreatOliveTree,
  "ArtGrowth.jpg": ArtGrowth,
  "ArtGuardHound.jpg": ArtGuardHound,
  "ArtWatchtower.jpg": ArtWatchtower,
  "ArtGuidance.jpg": ArtGuidance,
  "ArtTownHall.jpg": ArtTownHall,
  "ArtHallOfChampions.jpg": ArtHallOfChampions,
  "ArtHarvestSeason.jpg": ArtHarvestSeason,
  "ArtHeroesFeast.jpg": ArtHeroesFeast,
  "ArtHighPriest.jpg": ArtHighPriest,
  "ArtHarvestFestival.jpg": ArtHarvestFestival,
  "ArtHonorTheFallen.jpg": ArtHonorTheFallen,
  "ArtHoplite.jpg": ArtHoplite,
  "ArtHorseman.jpg": ArtHorseman,
  "ArtTempleGuard.jpg": ArtTempleGuard,
  "ArtLayFoundation.jpg": ArtLayFoundation,
  "ArtLeader.jpg": ArtLeader,
  "ArtLegionnaire.jpg": ArtLegionnaire,
  "ArtLibrary.jpg": ArtLibrary,
  "ArtLighthouse.jpg": ArtLighthouse,
  "ArtMarchOnward.jpg": ArtMarchOnward,
  "ArtMarketplace.jpg": ArtMarketplace,
  "ArtMercantileLeader.jpg": ArtMercantileLeader,
  "ArtMercenary.jpg": ArtMercenary,
  "ArtMerchant.jpg": ArtMerchant,
  "ArtConqueringLeader.jpg": ArtConqueringLeader,
  "ArtMilitia.jpg": ArtMilitia,
  "ArtMillOfDerion.jpg": ArtMillOfDerion,
  "ArtMine.jpg": ArtMine,
  "ArtNewRoads.jpg": ArtNewRoads,
  "ArtDemocraticOath.jpg": ArtDemocraticOath,
  "ArtAutocraticOath.jpg": ArtAutocraticOath,
  "ArtTheocraticOath.jpg": ArtTheocraticOath,
  "ArtOracle.jpg": ArtOracle,
  "ArtPiety.jpg": ArtPiety,
  "ArtPillage.jpg": ArtPillage,
  "ArtPiousLeader.jpg": ArtPiousLeader,
  "ArtWarsinger.jpg": ArtWarsinger,
  "ArtPrizedOx.jpg": ArtPrizedOx,
  "ArtProphet.jpg": ArtProphet,
  "ArtRanger.jpg": ArtRanger,
  "ArtRitualOfPolis.jpg": ArtRitualOfPolis,
  "ArtRitualOfHeroes.jpg": ArtRitualOfHeroes,
  "ArtRitual.jpg": ArtRitual,
  "ArtScavenge.jpg": ArtScavenge,
  "ArtScout.jpg": ArtScout,
  "ArtScribe.jpg": ArtScribe,
  "ArtPantheon.jpg": ArtPantheon,
  "ArtLaborCamp.jpg": ArtLaborCamp,
  "ArtSoldierOfTyros.jpg": ArtSoldierOfTyros,
  "ArtStonemason.jpg": ArtStonemason,
  "ArtStrategist.jpg": ArtStrategist,
  "ArtStrength.jpg": ArtStrength,
  "ArtSwordsman.jpg": ArtSwordsman,
  "ArtTemple.jpg": ArtTemple,
  "ArtGuardsman.jpg": ArtGuardsman,
  "ArtAltarOfStars.jpg": ArtAltarOfStars,
  "ArtTradeDeal.jpg": ArtTradeDeal,
  "ArtTradingPost.jpg": ArtTradingPost,
  "ArtTrainingCamp.jpg": ArtTrainingCamp,
  "ArtVillager.jpg": ArtVillager,
  "ArtVineyard.jpg": ArtVineyard,
  "ArtWanderingLeader.jpg": ArtWanderingLeader,
  "ArtWarHistorian.jpg": ArtWarHistorian,
  "ArtWarrior.jpg": ArtWarrior,
  "ArtWorship.jpg": ArtWorship,
};

export const TributeArt = {
  "TributeArtAllIn.jpg": TributeArtAllIn,
  "TributeArtBringPeace.jpg": TributeArtBringPeace,
  "TributeArtGrowBounty.jpg": TributeArtGrowBounty,
  "TributeArtGrowCommunity.jpg": TributeArtGrowCommunity,
  "TributeArtGrowConquest.jpg": TributeArtGrowConquest,
  "TributeArtGrowFaith.jpg": TributeArtGrowFaith,
  "TributeArtGrowLegend.jpg": TributeArtGrowLegend,
  "TributeArtGrowPolis.jpg": TributeArtGrowPolis,
  "TributeArtImpulsiveChoice.jpg": TributeArtImpulsiveChoice,
  "TributeArtOverpower.jpg": TributeArtOverpower,
  "TributeArtPatientChoice.jpg": TributeArtPatientChoice,
  "TributeArtPersevere.jpg": TributeArtPersevere,
  "TributeArtPunishWeakness.jpg": TributeArtPunishWeakness,
  "TributeArtSeekHumility.jpg": TributeArtSeekHumility,
  "TributeArtSeekModesty.jpg": TributeArtSeekModesty,
  "TributeArtSeekWonder.jpg": TributeArtSeekWonder,
  "TributeArtShowMight.jpg": TributeArtShowMight,
  "TributeArtShowPiety.jpg": TributeArtShowPiety,
};
